import { I18nComponente } from "@/types/gerais"

export const MEntradaDeBuscai18n: I18nComponente = {
  "pt-BR": {
    pesquisarFiltros: "pesquisar filtros..."
  },
  "es-CO": {
    pesquisarFiltros: "buscar filtros..."
  }
}
